import { EASYBIB, CITATION_MACHINE, BIBME, CITE_THIS_FOR_ME, SiteDomains } from '../types';
export var getCookieDomain = function getCookieDomain(site) {
  switch (site) {
    case EASYBIB:
      return SiteDomains.EB;
    case CITATION_MACHINE:
      return SiteDomains.CM;
    case BIBME:
      return SiteDomains.BM;
    case CITE_THIS_FOR_ME:
      return SiteDomains.CTFM;
    default:
      break;
  }
};